var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "live area"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M10.0001 7.99951L5.50012 3.49951L1.00012 7.99951",
    stroke: "#8E8E8E",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreArrow);
export default __webpack_public_path__ + "static/media/more-arrow.4b31e2a1dbd5d233826378950cbef2ef.svg";
export { ForwardRef as ReactComponent };